import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { PageHeader, message } from 'antd';
import { useParams } from 'react-router';
import { routes } from '../../utils/constants/routes';
import useAuthContext from '../../contexts/AuthContext';

const PageHeaderCustom = ({ title, extra, withSubRoutes, is_home = false }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const { dispatchAPI } = useAuthContext();
  const { id } = useParams();
  const splitPathname = pathname.split('/');
  const history = useHistory();

  // const [contract_ref, setContractRef] = useState(``);

  // // Grabs the contract reference from the database for the breadcrumb display
  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const { data } = await dispatchAPI('GET', {
  //         url: `/contracts/${id}`
  //       });
  //       setContractRef(data.ref);
  //     } catch (e) {
  //       message.error(`${e}`);
  //     }
  //   })();
  // }, []);

  const dynamicRoutes = [
    {
      path: routes.HOME,
      breadcrumbName: t('home.title')
    },
    ...(splitPathname[1] && splitPathname[1] !== ''
      ? [
          {
            path: `/${splitPathname[1]}`,
            breadcrumbName: withSubRoutes
              ? t(`basiclayout.menu.${splitPathname[1]}`)
              : t(`${splitPathname[1]}.title`)
          }
        ]
      : []),
    ...(splitPathname[2] && splitPathname[2] !== ''
      ? [
          {
            ...(withSubRoutes
              ? {
                  path: `/${splitPathname[1]}/${splitPathname[2]}`
                }
              : {}),
            breadcrumbName: t(`${splitPathname[1]}.${splitPathname[2]}.title`)
          }
        ]
      : [])
  ];

  const itemRender = (
    // eslint-disable-next-line react/prop-types
    { path, breadcrumbName, state, search, ...route },
    params,
    routesList
  ) => {
    const last = routesList.indexOf(route) === routesList.length - 1;
    return last ? (
      <span key={path}>{breadcrumbName}</span>
    ) : (
      <Link key={path} to={{ pathname: path, state, search }}>
        {breadcrumbName}
      </Link>
    );
  };

  const [style_comp, setStyle_comp] = useState({});

  useEffect(() => {
    is_home
      ? setStyle_comp({ background: 'none' })
      : setStyle_comp({ background: 'white' });
  }, []);

  return (
    <>
      {dynamicRoutes.length > 2 ? (
        <PageHeader
          breadcrumb={{ routes: dynamicRoutes, itemRender }}
          title={title}
          onBack={() => history.goBack()}
          ghost={false}
          extra={extra}
          style={style_comp}
        />
      ) : (
        <PageHeader
          breadcrumb={{ routes: dynamicRoutes, itemRender }}
          title={title}
          ghost={false}
          extra={extra}
          style={style_comp}
        />
      )}
    </>
  );
};

PageHeaderCustom.propTypes = {
  title: PropTypes.string.isRequired,
  extra: PropTypes.element,
  withSubRoutes: PropTypes.bool
};

PageHeaderCustom.defaultProps = {
  extra: null,
  withSubRoutes: false
};

export default PageHeaderCustom;
